var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _path22, _g2, _path23, _path24, _g3, _path25, _path26, _g4, _path27, _path28, _g5, _path29, _path30, _g6, _path31, _path32, _g7, _path33, _path34, _g8, _path35, _path36, _g9, _path37, _path38, _g0, _path39, _path40, _g1, _path41, _path42, _g10, _path43, _path44, _g11, _path45, _path46, _g12, _path47, _path48, _g13, _path49, _path50, _g14, _path51, _path52, _g15, _path53, _path54, _g16, _path55, _path56, _g17, _path57, _path58, _g18, _path59, _path60, _g19, _path61, _path62, _g20, _path63, _path64, _g21, _path65, _path66, _g22, _path67, _path68, _g23, _path69, _path70, _g24, _path71, _path72, _g25, _path73, _path74, _g26, _path75, _path76, _g27, _path77, _path78, _g28, _path79, _path80, _g29, _path81, _path82, _g30, _path83, _path84, _g31, _path85, _path86, _g32, _path87, _path88, _g33, _path89, _path90, _g34, _path91, _path92, _g35, _path93, _path94, _g36, _path95, _path96, _g37, _path97, _path98, _g38, _path99, _path100, _g39, _path101, _path102, _g40, _path103, _path104, _g41, _path105, _path106, _g42, _path107, _path108, _g43, _path109, _path110, _g44, _path111, _path112, _g45, _path113, _path114, _g46, _path115, _path116, _g47, _path117, _path118, _g48, _path119, _path120, _g49, _path121, _path122, _g50, _path123, _path124, _g51, _path125, _path126, _g52, _path127, _path128, _g53, _path129, _path130, _g54, _path131, _path132, _g55, _path133, _path134, _g56, _path135, _path136, _g57, _path137, _path138, _g58, _path139, _path140, _g59, _path141, _path142, _g60, _path143, _path144, _g61, _path145, _path146, _g62, _path147, _path148, _g63, _path149, _path150, _g64, _path151, _path152, _g65, _path153, _path154, _g66, _path155, _path156, _g67, _path157, _path158, _g68, _path159, _path160, _g69, _path161, _path162, _g70, _path163, _path164, _g71, _path165, _path166, _g72, _path167, _path168, _g73, _path169, _path170, _g74, _path171, _path172, _g75, _path173, _path174, _g76, _path175, _path176, _g77, _path177, _path178, _g78, _path179, _path180, _g79, _path181, _path182, _g80, _path183, _path184, _g81, _path185, _path186, _g82, _path187, _path188, _g83, _path189, _path190, _g84, _path191, _path192, _g85, _path193, _path194, _g86, _path195, _path196, _g87, _path197, _path198, _g88, _path199, _path200, _g89, _path201, _path202, _g90, _path203, _path204, _g91, _path205, _path206, _g92, _path207, _path208, _g93, _path209, _path210, _g94, _path211, _path212, _g95, _path213, _path214, _g96, _path215, _path216, _g97, _path217, _path218, _g98, _path219, _path220, _g99, _path221, _path222, _g100, _path223, _path224, _g101, _path225, _path226, _g102, _path227, _path228, _g103, _path229, _path230, _g104, _path231, _path232, _g105, _path233, _path234, _g106, _path235, _path236, _g107, _path237, _path238, _g108, _path239, _path240, _g109, _path241, _path242, _g110, _path243, _path244, _g111, _path245, _path246, _g112, _path247, _path248, _g113, _path249, _path250, _g114, _path251, _path252, _g115, _path253, _path254, _g116, _path255, _path256, _g117, _path257, _path258, _g118, _path259, _path260, _g119, _path261, _path262, _g120, _path263, _path264, _g121, _path265, _path266, _g122, _path267, _path268, _g123, _path269, _path270, _g124, _path271, _path272, _g125, _path273, _path274, _g126, _path275, _path276, _g127, _path277, _path278, _g128, _path279, _path280, _g129, _path281, _path282, _g130, _path283, _path284, _g131, _path285, _path286, _g132, _path287, _path288, _g133, _path289, _path290, _g134, _path291, _path292, _g135, _path293, _path294, _g136, _path295, _path296, _g137, _path297, _path298, _g138, _path299, _path300, _g139, _path301, _path302, _g140, _path303, _path304, _g141, _path305, _path306, _g142, _path307, _path308, _g143, _path309, _path310, _g144, _path311, _path312, _g145, _path313, _path314, _g146, _path315, _path316, _g147, _path317, _path318, _g148, _path319, _path320, _g149, _path321, _path322, _g150, _path323, _path324, _g151, _path325, _path326, _g152, _path327, _path328, _g153, _path329;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoHomeBlack = function SvgLogoHomeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M17.728.014A20.5 20.5 0 0 0 9.264 3.05l5.062 1.248zM11.824 7.46l2.502-3.162-5.062-1.234z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m11.824 7.46-2.56-4.396L8.221 8.17zM9.264 3.064a20.5 20.5 0 0 0-6.19 6.127L8.22 8.156zM7.506 11.73l.715-3.56-5.147 1.036zM14.325 4.298l3.403.85V.015zM0 17.603h5.161l-.843-3.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M7.506 11.73 3.074 9.206l1.244 5.02zM3.074 9.206A19.9 19.9 0 0 0 0 17.603l4.318-3.376zM14.325 4.298l-2.501 3.149a15.2 15.2 0 0 1 5.904-2.312z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m11.824 7.46-3.589.71-.73 3.56a15.4 15.4 0 0 1 4.318-4.27M7.506 11.73l-3.174 2.483.844 3.376a14.7 14.7 0 0 1 2.33-5.858M0 22.298a20.1 20.1 0 0 0 3.06 8.397l1.258-5.021z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m7.492 28.156-3.174-2.482-1.258 5.021zM3.074 30.695a20.5 20.5 0 0 0 6.176 6.142L8.206 31.73zM11.81 32.44l-3.59-.724 1.03 5.12zM4.318 25.674l.843-3.376H0zM17.728 39.886v-5.12l-3.688.823z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m11.81 32.44-2.56 4.397 5.061-1.248zM9.25 36.837a20.5 20.5 0 0 0 8.478 3.05l-3.403-4.284zM4.318 25.674l3.174 2.482a14.96 14.96 0 0 1-2.33-5.858zM7.491 28.156l.715 3.56 3.589.724a15.6 15.6 0 0 1-4.304-4.284"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m11.81 32.44 2.501 3.149 3.417-.823a15.6 15.6 0 0 1-5.919-2.326M22.46 39.887a20.5 20.5 0 0 0 8.464-3.036l-5.06-1.248zM28.365 32.44l-2.502 3.149 5.047 1.248z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m28.365 32.44 2.545 4.397 1.043-5.107zM30.91 36.837a20.5 20.5 0 0 0 6.19-6.128l-5.146 1.036z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m32.683 28.17-.73 3.56 5.147-1.02v-.015zM25.863 35.589l-3.403-.823v5.12zM40.174 22.298h-5.161l.843 3.66z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m32.683 28.17 4.417 2.525-1.244-5.021zM37.1 30.695a20.1 20.1 0 0 0 3.074-8.411l-4.318 3.376zM25.863 35.589l2.502-3.15a15.2 15.2 0 0 1-5.905 2.313zM28.365 32.454l3.589-.71.729-3.56a16 16 0 0 1-4.318 4.27"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m32.683 28.17 3.173-2.482-.843-3.376a15.1 15.1 0 0 1-2.33 5.858M40.174 17.603a20.1 20.1 0 0 0-3.06-8.397l-1.258 5.02z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m32.683 11.745 3.173 2.482 1.259-5.021zM32.682 11.745l4.432-2.54-5.16-1.02z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M37.115 9.206a20.5 20.5 0 0 0-6.177-6.142l1.044 5.106zM28.365 7.46l3.589.724-1.03-5.12zM35.857 14.227l-.844 3.376h5.161zM22.46.014V5.15l3.689-.837z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m28.365 7.46 2.56-4.396-5.062 1.248zM30.924 3.064a20.5 20.5 0 0 0-8.478-3.05l3.403 4.284zM35.857 14.227l-3.174-2.482a14.95 14.95 0 0 1 2.33 5.858zM32.682 11.745l-.714-3.56-3.589-.724a15.4 15.4 0 0 1 4.303 4.284"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m28.365 7.461-2.502-3.149-3.403.837a15.2 15.2 0 0 1 5.905 2.312M20.087 7.745l-3.603 6.184h7.22zM23.704 13.929l-3.617 6.199h7.206zM27.293 20.128l-3.589 6.198h7.206zM16.484 26.326l3.603-6.198H12.88z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.704 26.326 3.589-6.198h-7.206zM20.087 20.128l3.617-6.199h-7.22zM12.881 20.128 9.28 26.326h7.205zM20.087 7.745l-3.603 6.184h7.22z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.704 13.929-3.617 6.199h7.206zM27.293 20.128l-3.589 6.198h7.206zM16.484 26.326l3.603-6.198H12.88z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.704 26.326 3.589-6.198h-7.206zM20.087 20.128l3.617-6.199h-7.22zM12.881 20.128 9.28 26.326h7.205zM7.491 28.156l.73 3.56-5.147-1.021zM51.12 19.22c0-.525-.17-.922-.485-1.177q-.473-.384-1.287-.383c-.4 0-.786.085-1.144.24a2.9 2.9 0 0 0-.9.596l-.744-.893a3.8 3.8 0 0 1 1.301-.78 4.8 4.8 0 0 1 1.644-.284q.772 0 1.33.213c.386.142.686.34.93.595.242.242.428.54.542.88s.172.71.172 1.092v3.092c0 .241.014.497.029.752.014.255.042.482.085.652h-1.286a4 4 0 0 1-.115-1.007h-.043c-.257.383-.6.667-.986.88S49.29 24 48.748 24c-.286 0-.572-.029-.873-.114a2.3 2.3 0 0 1-.829-.368 2.2 2.2 0 0 1-.629-.667c-.171-.284-.243-.624-.243-1.035 0-.54.143-.965.443-1.291a2.9 2.9 0 0 1 1.144-.724c.472-.17 1.015-.27 1.601-.312.6-.042 1.187-.07 1.787-.07zm-.342 1.22c-.358 0-.715.014-1.087.042-.386.029-.729.1-1.015.17-.315.1-.558.227-.758.398-.2.17-.3.425-.3.723 0 .213.043.383.129.525q.129.213.343.34c.143.1.3.156.457.185s.344.042.53.042c.671 0 1.172-.198 1.53-.596.357-.383.528-.893.528-1.489v-.369h-.357zm6.39-6.27c0 .255-.1.468-.271.653a.94.94 0 0 1-.672.255.9.9 0 0 1-.658-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.172-.185.4-.255.658-.255.257 0 .486.085.672.255a.85.85 0 0 1 .271.638m-.228 9.646h-1.416v-7.093h1.416zm4.703 0h-1.5V13.234h3.416c.515 0 1 .043 1.458.156.458.1.872.27 1.216.51.343.228.614.525.814.908s.3.823.3 1.362c0 .78-.242 1.404-.728 1.887-.487.482-1.101.78-1.86.907l2.975 4.866h-1.802l-2.716-4.71h-1.601v4.71zm0-5.958h1.716c.357 0 .672-.028.986-.1.3-.056.572-.155.8-.297.23-.128.401-.312.53-.525s.2-.482.2-.794-.071-.596-.2-.795a1.7 1.7 0 0 0-.53-.524 2.1 2.1 0 0 0-.757-.27c-.3-.057-.6-.085-.915-.085h-1.83zm10.008-3.688c0 .255-.1.468-.272.653a.94.94 0 0 1-.672.255.93.93 0 0 1-.657-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.171-.185.4-.255.657-.255.258 0 .472.085.672.255a.85.85 0 0 1 .272.638m-.229 9.646h-1.415v-7.093h1.415zm3.703 1.205c.315.355.7.624 1.158.837s.944.312 1.43.312c.472 0 .872-.07 1.187-.199.314-.127.586-.311.771-.553.2-.24.33-.51.43-.822.085-.312.128-.667.128-1.036v-.908h-.028c-.258.398-.615.71-1.073.908a3.4 3.4 0 0 1-1.444.312c-.543 0-1.03-.099-1.487-.283a3.3 3.3 0 0 1-1.143-.78 3.6 3.6 0 0 1-.73-1.15 4 4 0 0 1-.257-1.418c0-.51.086-.993.258-1.433a3.6 3.6 0 0 1 .729-1.177 3.6 3.6 0 0 1 1.13-.794 3.6 3.6 0 0 1 1.472-.298c.514 0 1 .1 1.472.326.458.227.83.553 1.101 1.007h.029v-1.134h1.372v6.723c0 .525-.071 1.007-.2 1.49a3.2 3.2 0 0 1-.672 1.262c-.314.368-.73.666-1.23.865-.5.227-1.129.326-1.858.326a5.5 5.5 0 0 1-1.873-.34 4.8 4.8 0 0 1-1.615-.95zm.415-4.837c0 .326.043.653.157.936.1.298.257.568.457.795s.458.411.744.553c.3.142.629.213 1 .213.372 0 .701-.057 1.002-.199.3-.127.557-.312.771-.525.215-.227.386-.482.487-.794a2.8 2.8 0 0 0 .171-.979c0-.34-.057-.666-.171-.95a2.4 2.4 0 0 0-.5-.794 2.3 2.3 0 0 0-.773-.54 2.5 2.5 0 0 0-.986-.198c-.372 0-.7.071-1.001.199-.3.127-.543.312-.743.539s-.372.482-.458.794a3 3 0 0 0-.157.95m10.322-2.383c.172-.354.458-.652.872-.893a2.7 2.7 0 0 1 1.387-.383c.457 0 .858.085 1.187.24.328.157.6.37.829.625s.386.567.486.908c.1.354.157.723.157 1.12v4.398h-1.415v-3.93c0-.297-.029-.567-.072-.822a2.1 2.1 0 0 0-.243-.695 1.3 1.3 0 0 0-.486-.483c-.2-.113-.472-.17-.8-.17-.558 0-1.016.213-1.387.639-.358.425-.544.992-.544 1.702v3.759h-1.415V12.482h1.415v5.291h.029zm11.28.085h-1.901v3.688c0 .426.085.724.243.922.171.185.414.27.772.27.129 0 .271-.014.429-.028a2.3 2.3 0 0 0 .4-.114l.043 1.149c-.172.057-.358.1-.572.142q-.3.042-.643.042-1.008 0-1.544-.553c-.358-.369-.53-.922-.53-1.66v-3.843h-1.372v-1.163h1.373v-2.043h1.4v2.043h1.902z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__a",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.12 19.22c0-.525-.17-.922-.485-1.177q-.473-.384-1.287-.383c-.4 0-.786.085-1.144.24a2.9 2.9 0 0 0-.9.596l-.744-.893a3.8 3.8 0 0 1 1.301-.78 4.8 4.8 0 0 1 1.644-.284q.772 0 1.33.213c.386.142.686.34.93.595.242.242.428.54.542.88s.172.71.172 1.092v3.092c0 .241.014.497.029.752.014.255.042.482.085.652h-1.286a4 4 0 0 1-.115-1.007h-.043c-.257.383-.6.667-.986.88S49.29 24 48.748 24c-.286 0-.572-.029-.873-.114a2.3 2.3 0 0 1-.829-.368 2.2 2.2 0 0 1-.629-.667c-.171-.284-.243-.624-.243-1.035 0-.54.143-.965.443-1.291a2.9 2.9 0 0 1 1.144-.724c.472-.17 1.015-.27 1.601-.312.6-.042 1.187-.07 1.787-.07zm-.342 1.22c-.358 0-.715.014-1.087.042-.386.029-.729.1-1.015.17-.315.1-.558.227-.758.398-.2.17-.3.425-.3.723 0 .213.043.383.129.525q.129.213.343.34c.143.1.3.156.457.185s.344.042.53.042c.671 0 1.172-.198 1.53-.596.357-.383.528-.893.528-1.489v-.369h-.357zm6.39-6.27c0 .255-.1.468-.271.653a.94.94 0 0 1-.672.255.9.9 0 0 1-.658-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.172-.185.4-.255.658-.255.257 0 .486.085.672.255a.85.85 0 0 1 .271.638m-.228 9.646h-1.416v-7.093h1.416zm4.703 0h-1.5V13.234h3.416c.515 0 1 .043 1.458.156.458.1.872.27 1.216.51.343.228.614.525.814.908s.3.823.3 1.362c0 .78-.242 1.404-.728 1.887-.487.482-1.101.78-1.86.907l2.975 4.866h-1.802l-2.716-4.71h-1.601v4.71zm0-5.958h1.716c.357 0 .672-.028.986-.1.3-.056.572-.155.8-.297.23-.128.401-.312.53-.525s.2-.482.2-.794-.071-.596-.2-.795a1.7 1.7 0 0 0-.53-.524 2.1 2.1 0 0 0-.757-.27c-.3-.057-.6-.085-.915-.085h-1.83zm10.008-3.688c0 .255-.1.468-.272.653a.94.94 0 0 1-.672.255.93.93 0 0 1-.657-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.171-.185.4-.255.657-.255.258 0 .472.085.672.255a.85.85 0 0 1 .272.638m-.229 9.646h-1.415v-7.093h1.415zm3.703 1.205c.315.355.7.624 1.158.837s.944.312 1.43.312c.472 0 .872-.07 1.187-.199.314-.127.586-.311.771-.553.2-.24.33-.51.43-.822.085-.312.128-.667.128-1.036v-.908h-.028c-.258.398-.615.71-1.073.908a3.4 3.4 0 0 1-1.444.312c-.543 0-1.03-.099-1.487-.283a3.3 3.3 0 0 1-1.143-.78 3.6 3.6 0 0 1-.73-1.15 4 4 0 0 1-.257-1.418c0-.51.086-.993.258-1.433a3.6 3.6 0 0 1 .729-1.177 3.6 3.6 0 0 1 1.13-.794 3.6 3.6 0 0 1 1.472-.298c.514 0 1 .1 1.472.326.458.227.83.553 1.101 1.007h.029v-1.134h1.372v6.723c0 .525-.071 1.007-.2 1.49a3.2 3.2 0 0 1-.672 1.262c-.314.368-.73.666-1.23.865-.5.227-1.129.326-1.858.326a5.5 5.5 0 0 1-1.873-.34 4.8 4.8 0 0 1-1.615-.95zm.415-4.837c0 .326.043.653.157.936.1.298.257.568.457.795s.458.411.744.553c.3.142.629.213 1 .213.372 0 .701-.057 1.002-.199.3-.127.557-.312.771-.525.215-.227.386-.482.487-.794a2.8 2.8 0 0 0 .171-.979c0-.34-.057-.666-.171-.95a2.4 2.4 0 0 0-.5-.794 2.3 2.3 0 0 0-.773-.54 2.5 2.5 0 0 0-.986-.198c-.372 0-.7.071-1.001.199-.3.127-.543.312-.743.539s-.372.482-.458.794a3 3 0 0 0-.157.95m10.322-2.383c.172-.354.458-.652.872-.893a2.7 2.7 0 0 1 1.387-.383c.457 0 .858.085 1.187.24.328.157.6.37.829.625s.386.567.486.908c.1.354.157.723.157 1.12v4.398h-1.415v-3.93c0-.297-.029-.567-.072-.822a2.1 2.1 0 0 0-.243-.695 1.3 1.3 0 0 0-.486-.483c-.2-.113-.472-.17-.8-.17-.558 0-1.016.213-1.387.639-.358.425-.544.992-.544 1.702v3.759h-1.415V12.482h1.415v5.291h.029zm11.28.085h-1.901v3.688c0 .426.085.724.243.922.171.185.414.27.772.27.129 0 .271-.014.429-.028a2.3 2.3 0 0 0 .4-.114l.043 1.149c-.172.057-.358.1-.572.142q-.3.042-.643.042-1.008 0-1.544-.553c-.358-.369-.53-.922-.53-1.66v-3.843h-1.372v-1.163h1.373v-2.043h1.4v2.043h1.902z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__a)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__b",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M46.474 12.482h-.328v14.936h.328z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__c",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M46.817 12.482h-.328v14.936h.328z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__d",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M47.132 12.482h-.329v14.936h.33z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__e",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M47.46 12.482h-.328v14.936h.329z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__f",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M47.79 12.482h-.33v14.936h.33z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__g",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M48.133 12.482h-.329v14.936h.329z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__h",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M48.462 12.482h-.33v14.936h.33z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__i",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M48.79 12.482h-.328v14.936h.328z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__j",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M49.105 12.482h-.329v14.936h.329z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__k",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M49.434 12.482h-.329v14.936h.329z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__l",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M49.777 12.482h-.329v14.936h.329z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__m",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M50.106 12.482h-.33v14.936h.33z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__n",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M50.435 12.482h-.33v14.936h.33z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__o",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M50.749 12.482h-.329v14.936h.329z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__p",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M51.092 12.482h-.329v14.936h.33z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__q",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M51.421 12.482h-.329v14.936h.33z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__r",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M51.75 12.482h-.329v14.936h.329z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__s",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M52.079 12.482h-.33v14.936h.33z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__t",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M52.407 12.482h-.328v14.936h.328z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__u",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M52.736 12.482h-.328v14.936h.328z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__v",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M53.065 12.482h-.329v14.936h.33z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__w",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M53.394 12.482h-.329v14.936h.329z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__x",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M53.723 12.482h-.329v14.936h.329z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__y",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M54.052 12.482h-.33v14.936h.33z"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__z",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M54.38 12.482h-.328v14.936h.329z"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__A",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M54.71 12.482h-.33v14.936h.33z"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__B",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M55.038 12.482h-.329v14.936h.33z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__C",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M55.367 12.482h-.329v14.936h.329z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__D",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M55.696 12.482h-.33v14.936h.33z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__E",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M56.039 12.482h-.329v14.936h.329z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__F",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M56.354 12.482h-.33v14.936h.33z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__G",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M56.682 12.482h-.329v14.936h.33z"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__H",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M57.011 12.482h-.329v14.936h.33z"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__I",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M57.354 12.482h-.329v14.936h.33z"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__J",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M57.683 12.482h-.329v14.936h.33z"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__K",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M57.998 12.482h-.33v14.936h.33z"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__L",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M58.326 12.482h-.328v14.936h.328z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__M",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__M)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M58.655 12.482h-.329v14.936h.33z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__N",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M58.998 12.482h-.329v14.936H59z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__O",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M59.327 12.482h-.329v14.936h.33z"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__P",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M59.656 12.482h-.329v14.936h.329z"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__Q",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M59.97 12.482h-.328v14.936h.328z"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__R",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M60.314 12.482h-.33v14.936h.33z"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__S",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M60.643 12.482h-.33v14.936h.33z"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__T",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M60.971 12.482h-.328v14.936h.328z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__U",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M61.3 12.482h-.329v14.936h.329z"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__V",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M61.615 12.482h-.33v14.936h.33z"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__W",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M61.958 12.482h-.33v14.936h.33z"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__X",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M62.287 12.482h-.33v14.936h.33z"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__Y",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M62.615 12.482h-.328v14.936h.328z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__Z",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__Z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M62.944 12.482h-.329v14.936h.33z"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aa",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.273 12.482h-.329v14.936h.33z"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ab",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.602 12.482h-.329v14.936h.329z"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ac",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.93 12.482h-.328v14.936h.329z"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ad",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M64.26 12.482h-.33v14.936h.33z"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ae",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M64.588 12.482h-.328v14.936h.328z"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__af",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M64.917 12.482h-.329v14.936h.33z"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ag",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ag)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M65.246 12.482h-.329v14.936h.33z"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ah",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M65.575 12.482h-.329v14.936h.329z"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ai",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ai)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M65.904 12.482h-.329v14.936h.329z"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aj",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M66.233 12.482h-.33v14.936h.33z"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ak",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M66.576 12.482h-.33v14.936h.33z"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__al",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__al)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M66.905 12.482h-.33v14.936h.33z"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__am",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M67.219 12.482h-.329v14.936h.329z"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__an",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M67.548 12.482h-.329v14.936h.329z"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ao",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ao)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M67.877 12.482h-.33v14.936h.33z"
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ap",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ap)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M68.22 12.482h-.33v14.936h.33z"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aq",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M68.549 12.482h-.33v14.936h.33z"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ar",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ar)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M68.863 12.482h-.329v14.936h.33z"
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__as",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__as)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M69.192 12.482h-.329v14.936h.329z"
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__at",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M69.535 12.482h-.329v14.936h.33z"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__au",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__au)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M69.864 12.482h-.329v14.936h.329z"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__av",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__av)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M70.193 12.482h-.329v14.936h.329z"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aw",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M70.522 12.482h-.33v14.936h.33z"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ax",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ax)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M70.836 12.482h-.329v14.936h.33z"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ay",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ay)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.18 12.482h-.33v14.936h.33z"
  }))), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__az",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.508 12.482h-.329v14.936h.329z"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aA",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.837 12.482h-.329v14.936h.329z"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aB",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M72.166 12.482h-.33v14.936h.33z"
  }))), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aC",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M72.495 12.482h-.33v14.936h.33z"
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aD",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M72.824 12.482h-.33v14.936h.33z"
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aE",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M73.152 12.482h-.329v14.936h.33z"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aF",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M73.48 12.482h-.328v14.936h.329z"
  }))), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aG",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M73.81 12.482h-.329v14.936h.329z"
  }))), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aH",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M74.139 12.482h-.33v14.936h.33z"
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aI",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M74.468 12.482h-.33v14.936h.33z"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aJ",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M74.796 12.482h-.329v14.936h.33z"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aK",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M75.125 12.482h-.329v14.936h.33z"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aL",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M75.454 12.482h-.329v14.936h.33z"
  }))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aM",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M75.797 12.482h-.329v14.936h.33z"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aN",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M76.126 12.482h-.329v14.936h.329z"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aO",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M76.44 12.482h-.328v14.936h.328z"
  }))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aP",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M76.77 12.482h-.33v14.936h.33z"
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aQ",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M77.098 12.482h-.329v14.936h.33z"
  }))), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aR",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M77.441 12.482h-.329v14.936h.33z"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aS",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M77.77 12.482h-.329v14.936h.329z"
  }))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aT",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M78.085 12.482h-.33v14.936h.33z"
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aU",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M78.413 12.482h-.328v14.936h.328z"
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aV",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M78.742 12.482h-.329v14.936h.33z"
  }))), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aW",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M79.085 12.482h-.328v14.936h.328z"
  }))), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aX",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M79.414 12.482h-.329v14.936h.33z"
  }))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aY",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M79.743 12.482h-.329v14.936h.33z"
  }))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__aZ",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M80.058 12.482h-.33v14.936h.33z"
  }))), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__ba",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M80.4 12.482h-.328v14.936h.329z"
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bb",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M80.73 12.482h-.33v14.936h.33z"
  }))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bc",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M81.058 12.482h-.329v14.936h.33z"
  }))), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bd",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M81.387 12.482h-.329v14.936h.33z"
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__be",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M81.702 12.482h-.33v14.936h.33z"
  }))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bf",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M82.045 12.482h-.329v14.936h.329z"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bg",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M82.374 12.482h-.33v14.936h.33z"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bh",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M82.702 12.482h-.328v14.936h.328z"
  }))), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bi",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bi)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M83.031 12.482h-.329v14.936h.33z"
  }))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bj",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M83.36 12.482h-.329v14.936h.33z"
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bk",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M83.689 12.482h-.329v14.936h.329z"
  }))), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bl",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.018 12.482h-.329v14.936h.329z"
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bm",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.347 12.482h-.33v14.936h.33z"
  }))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bn",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.676 12.482h-.33v14.936h.33z"
  }))), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bo",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.004 12.482h-.329v14.936h.33z"
  }))), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bp",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.333 12.482h-.329v14.936h.329z"
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bq",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.662 12.482h-.329v14.936h.329z"
  }))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__br",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__br)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.99 12.482h-.328v14.936h.329z"
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bs",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M86.32 12.482h-.33v14.936h.33z"
  }))), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bt",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M86.663 12.482h-.33v14.936h.33z"
  }))), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bu",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M86.991 12.482h-.328v14.936h.328z"
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bv",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.306 12.482h-.329v14.936h.33z"
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bw",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.635 12.482h-.329v14.936h.329z"
  }))), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bx",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.964 12.482h-.33v14.936h.33z"
  }))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__by",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__by)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M88.307 12.482h-.329v14.936h.329z"
  }))), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bz",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M88.636 12.482h-.33v14.936h.33z"
  }))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bA",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M88.95 12.482h-.329v14.936h.33z"
  }))), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bB",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M89.279 12.482h-.329v14.936h.329z"
  }))), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bC",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M89.622 12.482h-.329v14.936h.329z"
  }))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bD",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M89.95 12.482h-.328v14.936h.329z"
  }))), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bE",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M90.28 12.482h-.33v14.936h.33z"
  }))), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bF",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M90.609 12.482h-.33v14.936h.33z"
  }))), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bG",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M90.923 12.482h-.329v14.936h.33z"
  }))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bH",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M91.266 12.482h-.329v14.936h.33z"
  }))), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bI",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M91.595 12.482h-.329v14.936h.33z"
  }))), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bJ",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M91.924 12.482h-.329v14.936h.329z"
  }))), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bK",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M92.253 12.482h-.33v14.936h.33z"
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bL",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M92.582 12.482h-.33v14.936h.33z"
  }))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bM",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M92.91 12.482h-.328v14.936h.328z"
  }))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bN",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M93.24 12.482h-.33v14.936h.33z"
  }))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bO",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M93.568 12.482h-.329v14.936h.33z"
  }))), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bP",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M93.897 12.482h-.329v14.936h.329z"
  }))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bQ",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M94.226 12.482h-.329v14.936h.329z"
  }))), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bR",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M94.554 12.482h-.328v14.936h.328z"
  }))), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bS",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M94.883 12.482h-.329v14.936h.33z"
  }))), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bT",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M95.212 12.482h-.329v14.936h.33z"
  }))), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bU",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M95.541 12.482h-.329v14.936h.329z"
  }))), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bV",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M95.884 12.482h-.329v14.936h.33z"
  }))), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bW",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M96.213 12.482h-.329v14.936h.329z"
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bX",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M96.528 12.482h-.33v14.936h.33z"
  }))), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bY",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M96.856 12.482h-.328v14.936h.328z"
  }))), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-home-black_svg__bZ",
    width: 52,
    height: 16,
    x: 46,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-home-black_svg__bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-.329v14.936h.329z"
  }))), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.185 12.482h-51.04v14.936h51.04z"
  }))));
};
export default SvgLogoHomeBlack;